/**
 * Fehler der Verbindungsschicht in eine gemeinsame Form bringen.
 *
 * Herausgeloest aus connection.ts, weil die Wege ueber Kabel und ueber Funk
 * beide dieselbe Umwandlung brauchen.
 */

import { DeviceError } from "@microbit/microbit-connection";
import { PicoReplError } from "./raw-repl";

export function asDeviceError(error: unknown): DeviceError {
  if (error instanceof DeviceError) {
    return error;
  }
  if (error instanceof PicoReplError) {
    return new DeviceError({
      code: "connection-error",
      message: error.detail ? `${error.message} ${error.detail}` : error.message,
      cause: error,
    });
  }
  return new DeviceError({
    code: "connection-error",
    message: error instanceof Error ? error.message : String(error),
    cause: error,
  });
}
